import { handleActions } from "redux-actions";

import {
  SET_DATES,
  UPDATE_DATES,
  FETCH_CURRENT_USER_SUCCESS,
  SET_UPDATES_LOADING,
  FETCH_SECTION_DATA_SUCCESS
} from "./dailyPulseSagas";

export const actionCreators = {};

const initialState = {
  currentUser: {},
  date: null,
  sections: {}
};

export default handleActions(
  {
    [SET_UPDATES_LOADING]: (state, { payload: { key, isLoading } }) => {
      return {
        ...state,
        sections: { ...state.sections, [key]: { ...state.sections[key], isLoading } }
      };
    },
    [SET_DATES]: (state) => ({
      ...state,
      date: state.currentUser.calendarEndDate
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      date: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({ ...state, currentUser: action.payload }),
    [FETCH_SECTION_DATA_SUCCESS]: (state, { payload: { key, chartData } }) => {
      return {
        ...state,
        sections: {
          ...state.sections,

          [key]: {
            isLoading: false,
            chartData
          }
        }
      };
    }
  },
  initialState
);
